import React from 'react';
import Dropzone from 'react-dropzone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/pro-light-svg-icons/faUpload';

export default class FileUpload extends React.Component {
    /**
     * @var state
     * @type {{files: null, uploading: boolean, canUpload: boolean}}
     */
    state = {
        files: null,
        uploading: false,
        canUpload: false,
    };

    /**
     * @var fileInput
     */
    fileInput = null;

    /**
     * @method handleOnChange
     */
    handleOnChange = () => {
        if (this.props.onChange !== undefined) {
            if (this.state.files === null) {
                return this.props.onChange(null);
            }

            this.props.onChange(this.props.multiple ? this.state.files : this.state.files[0]);

            if (this.props.clearAfter) {
                this.setState({
                    files: null,
                    canUpload: false,
                });
            }
        }
    };

    /**
     * @method handleFileInput
     * @param {object} e
     * @param {object} e.target
     * @param {UploadFile[]} e.target.files
     */
    handleFileInput = (e) => {
        if (!this.fileInput) return;

        if (e.target.files && e.target.files.length > 0) {
            this.setState({
                canUpload: true,
                uploading: false,
                files: e.target.files,
            }, this.handleOnChange);
        }
    };

    /**
     * @method handleFileDrop
     * @param {UploadFile[]} files
     */
    handleFileDrop = (files) => this.setState({
        canUpload: true,
        uploading: false,
        files
    }, this.handleOnChange);

    /**
     * @method handleOpenFileInput
     */
    handleOpenFileInput = () => this.fileInput.click();

    /**
     * @method toggleUpload
     */
    toggleUpload = () => this.setState({
        uploading: !this.state.uploading,
    });

    /**
     * @method handleCancel
     */
    handleCancel = () => this.setState({
        canUpload: false,
        files: null,
    }, this.handleOnChange);

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        const { uploading, canUpload, files } = this.state;

        return (
            <React.Fragment>
                <div>
                    <div className="mt-2 flex items-center">
                    <span className="rounded-md w-full">
                      {!canUpload && (
                          <button
                              type="button"
                              className={
                                  'py-2 px-3 border border-gray-300 rounded-md ' +
                                  'text-sm leading-4 font-medium text-gray-700 ' +
                                  'hover:text-gray-500 focus:outline-none ' +
                                  'focus:border-blue-300 ease-in-out ' +
                                  'focus:shadow-outline-blue active:bg-gray-50 ' +
                                  'active:text-gray-800 transition duration-150 '
                              }
                              onClick={this.toggleUpload}>
                              {uploading ? 'Cancel' : 'Select'}
                          </button>
                      )}

                        {canUpload && (
                            <React.Fragment>
                                <div className="flex rounded-md shadow-sm">
                                    <div
                                        className="relative grow focus-within:z-10">
                                        <input
                                            className="form-input block w-full rounded-none rounded-l-md transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                            readOnly={true}
                                            value={files ? Object.values(files).map(file => file.name) : ''}
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        className={
                                            '-ml-px py-2 px-3 border border-gray-300 ' +
                                            'rounded-r-md text-sm leading-4 font-medium ' +
                                            'text-gray-700 hover:text-gray-500 ' +
                                            'focus:outline-none focus:border-blue-300 ' +
                                            'focus:shadow-outline-blue ' +
                                            'active:bg-gray-50 active:text-gray-800 ' +
                                            'transition duration-150 ease-in-out'
                                        }
                                        onClick={this.handleCancel}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </React.Fragment>
                        )}
            </span>
                    </div>
                </div>

                {uploading && (
                    <div className="mt-6">
                        <Dropzone onDropAccepted={this.handleFileDrop}>
                            {({ getRootProps, getInputProps }) => (
                                <div
                                    className={
                                        'mt-2 flex justify-center px-6 pt-5 pb-6 ' +
                                        'border-2 border-gray-300 border-dashed ' +
                                        'rounded-md'
                                    }
                                    {...getRootProps()}>
                                    <input
                                        type={'file'}
                                        className={'hidden'}
                                        {...getInputProps()}
                                        onChange={this.handleFileInput}
                                        accept={this.props.type}
                                        multiple={this.props.multiple}
                                        ref={(ref) => {
                                            this.fileInput = ref;
                                        }}
                                    />

                                    <div className="text-center">
                    <span className="text-gray-400">
                      <FontAwesomeIcon icon={faUpload} size="2x"/>
                    </span>

                                        <p className="mt-1 text-sm text-gray-600">
                                            <button
                                                type={'button'}
                                                className={
                                                    'font-medium text-indigo-600 ' +
                                                    'hover:text-indigo-500 ' +
                                                    'focus:outline-none focus:underline ' +
                                                    'transition duration-150 ease-in-out'
                                                }
                                                onClick={this.handleOpenFileInput}>
                                                Upload a file
                                            </button>
                                            {' '}
                                            or drag and drop
                                        </p>

                                        <p className="mt-1 text-xs text-gray-500">
                                            {this.props.message ?? 'PNG, JPG, GIF up to 10MB'}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                    </div>
                )}
            </React.Fragment>
        );
    };
}
